module.exports = {
  PRODUCT_CATEGORY_CODE: {
    RECEIVE_PAYMENTS: 'RECEIVE_PAYMENTS',
    SEND_PAYMENTS: 'SEND_PAYMENTS',
    TRANSFERS: 'TRANSFERS'
  },
  PRODUCT_SUBCATEGORY_CODE: {
    CARD_PAYMENTS: 'CARD_PAYMENTS',
    EXPRESS: 'EXPRESS',
    INSTANT: 'INSTANT',
    WIRE: 'WIRE'
  },
  PRODUCT_STATUS: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
  }
};
